module.exports = __webpack_public_path__ + "img/zan_c.d4707626.svg";